export default __webpack_public_path__ + "static/bg-drinks-7a46effc48fe6aa421443905494871a2.jpg";